import { clients as contentClients } from "../content";
import { SKILL_IDS } from "../types/enums";
import type { SkillId } from "../types";
import { SAVE_VERSION, type SaveGame } from "../types/player";

function emptySkills(): Record<SkillId, number> {
  return Object.fromEntries(SKILL_IDS.map((id) => [id, 0])) as Record<SkillId, number>;
}

/**
 * A fresh, valid save: level 1, no progress, clients with requiredReputation 0
 * already unlocked. Returns a new object tree on every call.
 */
export function createDefaultSaveGame(): SaveGame {
  return {
    saveVersion: SAVE_VERSION,
    player: {
      id: "player",
      name: "",
      level: 1,
      xp: 0,
      money: 300,
      reputation: 0,
      skillPoints: 0,
      skills: emptySkills(),
      ownedTools: [],
      completedContracts: [],
      achievements: [],
    },
    agency: { name: "" },
    clientTrust: {},
    unlockedClients: contentClients
      .filter((client) => (client.requiredReputation ?? 0) === 0)
      .map((client) => client.id),
    streak: { current: 0, longest: 0, lastClaimDate: "" },
    offers: { available: [], urgent: null },
    lastSaveTime: 0,
    resultHistory: [],
    training: { bought: 0 },
  };
}
